/* ------------------------------
  USER ACCOUNT
------------------------------ */
/** @returns {null|UserAccount} */
export const findUserAccount = (userData, type, company) =>
  userData.accounts.find(a => a.type === type && a.company === company) || null;
